'use strict';

/**
* ScrollBar custom element.
*/
JQX('jqx-scroll-bar', function (_JQX$BaseElement) {
    babelHelpers.inherits(ScrollBar, _JQX$BaseElement);

    function ScrollBar() {
        babelHelpers.classCallCheck(this, ScrollBar);
        return babelHelpers.possibleConstructorReturn(this, (ScrollBar.__proto__ || Object.getPrototypeOf(ScrollBar)).apply(this, arguments));
    }

    babelHelpers.createClass(ScrollBar, [{
        key: 'template',


        /** ScrollBar's template. */
        value: function template() {
            var template = '<div id="container" class="jqx-container">\n                    <jqx-repeat-button disabled="[[disabled]]" id="nearButton" class ="jqx-scroll-button">\n                        <div id="nearArrow" class="jqx-arrow"></div>\n                    </jqx-repeat-button>\n                    <div  id="track" class="jqx-track">\n                        <div id="thumb" class="jqx-thumb"></div>\n                    </div>\n                    <jqx-repeat-button disabled="[[disabled]]" id="farButton" class="jqx-scroll-button">\n                        <div id="farArrow" class="jqx-arrow"></div>\n                    </jqx-repeat-button>\n            </div>';

            return template;
        }
    }, {
        key: '_calculateThumbSize',
        value: function _calculateThumbSize(scrollAreaSize) {
            var that = this;
            var positions = that.max - that.min;

            var size = 0;

            if (positions > 1) {
                size = scrollAreaSize / (positions + scrollAreaSize) * scrollAreaSize;

                if (that.$.thumb.className.indexOf('jqx-hidden') >= 0) {
                    that.$thumb.removeClass('jqx-hidden');
                }
            } else if (positions <= 1) {
                that.$thumb.addClass('jqx-hidden');
            }

            return Math.max(10, Math.min(size, scrollAreaSize));
        }
    }, {
        key: '_dragStartHandler',
        value: function _dragStartHandler(event) {
            var that = this;

            if (that.disabled) {
                return;
            }

            that.thumbCapture = true;
            that.dragStartX = event.clientX;
            that.dragStartY = event.clientY;
            that.dragStartValue = that.value;

            if (event.originalEvent) {
                event.originalEvent.stopPropagation();
                event.originalEvent.preventDefault();
            }
        }
    }, {
        key: '_dragHandler',
        value: function _dragHandler(event) {
            var that = this;

            if (that.thumbCapture !== true) {
                return;
            }

            var ratio = (that.max - that.min) / (that.scrollBarSize - that.thumbSize);
            var offsetValue = that.orientation === 'horizontal' ? (event.clientX - that.dragStartX) * ratio : (event.clientY - that.dragStartY) * ratio;
            var step = offsetValue;

            if (that.rightToLeft && that.orientation === 'horizontal') {
                step = -offsetValue;
            }
            that._updateValue(that.dragStartValue + step);

            if (event.originalEvent) {
                event.originalEvent.stopPropagation();
                event.originalEvent.preventDefault();
            }
        }
    }, {
        key: '_dragEndHandler',
        value: function _dragEndHandler() {
            var that = this;

            if (that._trackDownTimer) {
                clearInterval(that._trackDownTimer);
                that._trackDownTimer = null;
            }

            if (!that.thumbCapture) {
                return;
            }

            that.thumbCapture = false;
            that.$track.removeClass('jqx-dragged');
        }
    }, {
        key: '_farButtonClickHandler',
        value: function _farButtonClickHandler() {
            var that = this;

            if (that.disabled) {
                return;
            }

            that._updateValue(that.value + that.step);
        }
    }, {
        key: '_nearButtonClickHandler',
        value: function _nearButtonClickHandler() {
            var that = this;

            if (that.disabled) {
                return;
            }

            that._updateValue(that.value - that.step);
        }
    }, {
        key: 'propertyChangedHandler',
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            babelHelpers.get(ScrollBar.prototype.__proto__ || Object.getPrototypeOf(ScrollBar.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);

            var that = this;

            switch (propertyName) {
                case 'min':
                case 'max':
                case 'orientation':
                    {
                        that._layout();
                        break;
                    }
                case 'value':
                    that._updateValue(oldValue, newValue);
                    break;
            }
        }
    }, {
        key: 'ready',
        value: function ready() {
            babelHelpers.get(ScrollBar.prototype.__proto__ || Object.getPrototypeOf(ScrollBar.prototype), 'ready', this).call(this);

            var that = this;

            that._layout();
        }
    }, {
        key: '_resizeHandler',
        value: function _resizeHandler() {
            var that = this;

            that._layout();
        }
    }, {
        key: '_layout',
        value: function _layout() {
            var that = this;

            that.scrollBarSize = that.orientation === 'horizontal' ? that.$.track.offsetWidth : that.$.track.offsetHeight;
            that.thumbSize = that._calculateThumbSize(that.scrollBarSize);

            that.$.thumb.removeAttribute('style');

            if (that.orientation === 'horizontal') {
                that.$.thumb.style.width = that.thumbSize + 'px';
            } else {
                that.$.thumb.style.height = that.thumbSize + 'px';
            }

            that.$nearArrow.removeClass('jqx-arrow-left jqx-arrow-up');
            that.$farArrow.removeClass('jqx-arrow-right jqx-arrow-down');

            if (that.orientation === 'horizontal') {
                that.$nearArrow.addClass('jqx-arrow-left');
                that.$farArrow.addClass('jqx-arrow-right');
            } else {
                that.$nearArrow.addClass('jqx-arrow-up');
                that.$farArrow.addClass('jqx-arrow-down');
            }

            that._updateThumbPosition();
        }
    }, {
        key: '_selectStartHandler',
        value: function _selectStartHandler(event) {
            var that = this;

            if (that.thumbCapture) {
                event.preventDefault();
            }
        }
    }, {
        key: '_trackDownHandler',
        value: function _trackDownHandler(event) {
            var that = this;

            if (event.target !== that.$.track) {
                return;
            }

            that._trackDownTimer = setInterval(function () {
                that._trackClickHandler(event);
            }, 50);
        }
    }, {
        key: '_trackClickHandler',
        value: function _trackClickHandler(event) {
            var that = this;

            if (that.disabled || event.target !== that.$.track) {
                return;
            }

            var thumbRect = that.$.thumb.getBoundingClientRect();
            var x = event.pageX;
            var y = event.pageY;

            if (that.orientation === 'horizontal') {
                if (x > thumbRect.right) {
                    that._updateValue(that.value + that.largeStep);
                } else if (x < thumbRect.left) {
                    that._updateValue(that.value - that.largeStep);
                }
            } else {
                if (y > thumbRect.bottom) {
                    that._updateValue(that.value + that.largeStep);
                } else if (y < thumbRect.top) {
                    that._updateValue(that.value - that.largeStep);
                }
            }
        }
    }, {
        key: '_updateValue',
        value: function _updateValue(oldValue, newValue) {
            var that = this;

            if (arguments.length === 1) {
                newValue = oldValue;
                oldValue = that.value;
            }

            if (newValue === undefined || isNaN(newValue)) {
                newValue = that.min;
            }

            if (newValue > that.max) {
                newValue = that.max;
            }

            if (newValue < that.min) {
                newValue = that.min;
            }

            if (oldValue !== newValue) {
                that.value = newValue;
                that._updateThumbPosition();

                that.$.fireEvent('change', { 'value': that.value, 'oldValue': oldValue });
            }
        }
    }, {
        key: '_updateThumbPosition',
        value: function _updateThumbPosition() {
            var that = this;

            var height = that.$.track.offsetHeight;
            var width = that.$.track.offsetWidth;

            var scrollBarSize = that.orientation === 'horizontal' ? width : height;
            var thumbSize = that._calculateThumbSize(scrollBarSize);
            var maxThumbPosition = that.orientation === 'horizontal' ? width - thumbSize : height - thumbSize;

            var thumbPosition = (scrollBarSize - thumbSize) / (that.max - that.min) * (that.value - that.min);

            if (that.rightToLeft && that.orientation === 'horizontal') {
                thumbPosition = (scrollBarSize - thumbSize) / (that.max - that.min) * (that.max - that.value - that.min);
            }

            thumbPosition = Math.min(maxThumbPosition, Math.max(0, thumbPosition));

            if (that.orientation === 'vertical') {
                that.$.thumb.style.top = thumbPosition + 'px';
            } else {
                that.$.thumb.style.left = thumbPosition + 'px';
            }
        }
    }], [{
        key: 'properties',

        // ScrollBar's properties.
        get: function get() {
            return {
                'largeStep': {
                    type: 'integer',
                    value: 100
                },
                'min': {
                    type: 'integer',
                    value: 0
                },
                'max': {
                    type: 'integer',
                    value: 1000
                },
                'orientation': {
                    type: 'string',
                    value: 'horizontal',
                    allowedValues: ['horizontal', 'vertical']
                },
                'step': {
                    type: 'integer',
                    value: 10
                },
                'value': {
                    type: 'integer',
                    value: 0
                }
            };
        }
    }, {
        key: 'listeners',
        get: function get() {
            return {
                'nearButton.click': '_nearButtonClickHandler',
                'farButton.click': '_farButtonClickHandler',
                'track.down': '_trackDownHandler',
                'track.click': '_trackClickHandler',
                'thumb.down': '_dragStartHandler',
                'document.move': '_dragHandler',
                'document.up': '_dragEndHandler',
                'document.selectstart': '_selectStartHandler',
                'resize': '_resizeHandler'
            };
        }
    }]);
    return ScrollBar;
}(JQX.BaseElement));